/*
 * @Author: yaoyuting
 * @Date: 2019-08-27 11:38:24
 * @LastEditors: yaoyuting
 * @LastEditTime: 2021-05-15 15:00:12
 * @Descripttion:
 */
export function trimHtml(str) {
  if (!str) return "";
  str = str.replace(/(\n)/g, "");
  str = str.replace(/(\t)/g, "");
  str = str.replace(/(\r)/g, "");
  str = str.replace(/<\/?[^>]*>/g, "");
  // str = str.replace(/\s*/g, '');
  str = str.replace(/<[^>]*>/g, "");
  return str;
}
// export function goPAGE() {
//   if (
//     navigator.userAgent.match(
//       /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
//     )
//   ) {
//     /* window.location.href="你的手机版地址"; */
//     return "m";
//   }
//   /* window.location.href="你的电脑版地址";    */
//   return "pc";
// }
export function goPAGE() {
  if (
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    /* window.location.href="你的手机版地址"; */
 //   window.location.href="http://192.168.1.68:8083/#/Index"
    return "Index";
  }
  /* window.location.href="你的电脑版地址";    */
  return "Index";
}
export function getNavigator() {
  const u = navigator.userAgent;
  // console.log('navigator.userAgent\n\n\n\n', u)
  const obj = {};
  const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; // g
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
  obj.device = "h5";
  if (isAndroid) {
    obj.device = "android";
  }
  if (isIOS) {
    obj.device = "ios";
  }
  obj.isApp = u.indexOf("dianjiemian") > -1;
  // if (process.env.NODE_ENV != 'production') {
  // 	obj.isApp = true
  // }
  return obj;
}

// export const baseURL = "http://47.98.110.210:8081/"
// http://47.115.200.174:8080
export function FormatTime(number, format) {
  if (number == "0" || !number) return " ";
  const formateArr = ["Y", "M", "D", "h", "m", "s"];
  const returnArr = [];
  const date = new Date(number);
  returnArr.push(date.getFullYear());
  returnArr.push(formatNumber(date.getMonth() + 1));
  returnArr.push(formatNumber(date.getDate()));
  returnArr.push(formatNumber(date.getHours()));
  returnArr.push(formatNumber(date.getMinutes()));
  returnArr.push(formatNumber(date.getSeconds()));
  for (const i in returnArr) {
    format = format.replace(formateArr[i], returnArr[i]);
  }
  return format;
}

function formatNumber(n) {
  n = n.toString();
  return n[1] ? n : `0${n}`;
}

/*
  ios端浏览器日期格式化有兼容性问题, ios只识别yyyy/mm/dd这类斜杠格式的日期。
  如2022-03-25 10:03:59 要转换成2022/03/25 10:03:59
*/
export function formatDateStr(dateStr) {
  if (!dateStr || typeof dateStr !== "string") return;
  return /-/g.test(dateStr) ? dateStr.replace(/-/g, "/") : dateStr;
}
export function getSubStr(str, num1, num2) {
  var subStr1 = str.substr(num1, num2);
  var subStr2 = str.substr(str.length - num2, num2);
  var subStr = subStr1 + "..." + subStr2;
  return subStr;
}
export function timestampConvertTime(timestamp) {
//  console.log(timestamp);
  if (timestamp !== "") {
    var timestampr = timestamp.split("-")[2];
 //   console.log(timestampr);

    timestamp = timestamp.split("-")[1];
    if (timestamp == "01") {
      timestamp = "January";
    } else if (timestamp == "02") {
      timestamp = "February ";
    } else if (timestamp == "03") {
      timestamp = "March";
    } else if (timestamp == "04") {
      timestamp = "April";
    } else if (timestamp == "05") {
      timestamp = "May";
    } else if (timestamp == "06") {
      timestamp = "June";
    } else if (timestamp == "07") {
      timestamp = "July";
    } else if (timestamp == "08") {
      timestamp = "August";
    } else if (timestamp == "09") {
      timestamp = "September";
    } else if (timestamp == "10") {
      timestamp = "October";
    } else if (timestamp == "11") {
      timestamp = "November";
    } else if (timestamp == "12") {
      timestamp = "December";
    }
    return timestamp + "-" + timestampr;
  }else{
    return false;
  }
}
export function timestampConvertTime1(timestamp) {
  let _timestamp = timestamp;
  if (_timestamp.length == 10) {
    _timestamp = Number(_timestamp) * 1000;
  }
  var date = new Date(Number(_timestamp)); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + "-";
  var M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
  var h =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  var m =
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
    ":";
  var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

  return M + D; //2020-07-30 01:05:54
}
export function timestampConvertTime2(timestamp) {
  let _timestamp = timestamp;
  if (_timestamp.length == 10) {
    _timestamp = Number(_timestamp) * 1000;
  }
  var date = new Date(Number(_timestamp)); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + "-";
  var M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
  var h =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  var m =
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
    ":";
  var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

  return Y + M + D; //2020-07-30 01:05:54
}